import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import Navbar from "@/components/Navbar";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="forgot-page" className="min-h-screen bg-[#FBF9F6]">
      <Navbar />
      <main className="max-w-md mx-auto px-4 pt-16 pb-24">
        <div className="text-center mb-10 anim-fade-up">
          <h1 className="font-serif text-4xl sm:text-5xl tracking-tight text-[#2D2926]">
            Reset your password
          </h1>
          <p className="mt-2 text-[#6B655D]">
            We'll send a reset link to your email.
          </p>
        </div>

        <div className="surface-card p-8 anim-fade-up anim-delay-1">
          {sent ? (
            <div data-testid="forgot-sent" className="text-center">
              <p className="font-serif text-2xl text-[#2D2926] mb-3">Check your email.</p>
              <p className="text-[#6B655D] mb-6">
                If an account exists for that address, we've sent a reset link. It's good for one hour.
              </p>
              <Link
                to="/login"
                className="inline-flex items-center gap-2 bg-[#2D2926] text-white hover:bg-[#1A1715] rounded-full px-5 py-2.5 text-sm transition-colors"
              >
                Back to sign in
              </Link>
            </div>
          ) : (
            <form onSubmit={onSubmit} className="space-y-4">
              <div>
                <label className="block text-xs uppercase tracking-wider text-[#9A938A] mb-2">
                  Email
                </label>
                <input
                  type="email"
                  required
                  data-testid="forgot-email-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-white border border-[#E6E2D8] rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#D4A574] transition-all placeholder-[#9A938A]"
                  placeholder="you@work.com"
                  autoComplete="email"
                />
              </div>
              <button
                type="submit"
                disabled={submitting}
                data-testid="forgot-submit-btn"
                className="w-full bg-[#2D2926] text-white hover:bg-[#1A1715] rounded-full px-6 py-3 text-sm font-medium transition-colors disabled:opacity-60"
              >
                {submitting ? "Sending…" : "Send reset link"}
              </button>
            </form>
          )}
        </div>

        <p className="mt-8 text-center text-sm text-[#6B655D]">
          Remembered it?{" "}
          <Link
            to="/login"
            className="text-[#2D2926] hover:text-[#C29260] underline underline-offset-4"
          >
            Sign in
          </Link>
        </p>
      </main>
    </div>
  );
}
